<input #fileInput id="fileInput" type="file" name="csv" ng2FileSelect [uploader]="uploader" [hidden]="true" />
<label for="fileInput" class="mat-button mat-raised-button">UPLOAD CSV FILE</label>
<mat-progress-bar mode="determinate" [value]="uploader.progress" *ngIf="uploader.isUploading"></mat-progress-bar>
<div *ngIf="message">
	<br/>
	Imported Customers:
	<div *ngFor="let patientName of message; let i=index ">
		{{ patientName }}
	</div>
</div>